import React from 'react';
import { Tab, Tabs } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';

const {
  arrayOf, func, number, shape, string
} = proptypes;

const SnapshotTabBar = ({ tabs, activeIndex, onTabClick }) => (
  <div className="sui-flex sui-items-center sui-w-full sui-border-b-1 sui-border-solid sui-border-primary">
    <div
      className="sui-flex-1 sui-min-w-0 [&_[role=tablist]]:sui-gap-2
      [&_[role=tab]]:sui-min-w-0 [&_[role=tab]]:sui-px-4"
    >
      <Tabs
        value={activeIndex}
        aria-label="dashboard-snapshot-category-tabs"
        variant="scrollable"
        style={{ borderBottom: 'none' }}
      >
        {tabs.map((tab, index) => (
          <Tab
            key={tab.key}
            label={tab.label}
            value={index}
            onClick={(ev) => onTabClick(ev, index)}
          />
        ))}
      </Tabs>
    </div>
  </div>
);

SnapshotTabBar.propTypes = {
  activeIndex: number.isRequired,
  onTabClick: func.isRequired,
  tabs: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ).isRequired,
};

export { SnapshotTabBar };
